import { DocumentStoreGetters } from "@/constants/store/document/documentStoreConstants";
import { SiteDocument } from "@/dataModel";
import { DocumentState } from "@/typings/store/states/DocumentStoreState";

export default {
  [DocumentStoreGetters.GET_SELECTED_DOCUMENT]: (state: DocumentState): SiteDocument | null => state.document,
};
